<template>
  <div>
    <v-card class="mx-auto unitStockCard" max-width="250" :loading="loading">
      <template v-slot:loader="{ isActive }">
        <v-progress-linear
          :active="isActive"
          color="deep-purple"
          height="4"
          indeterminate
        ></v-progress-linear>
      </template>
      <div style="text-align: center;">
        <div class="card-title bold">{{ unit.name }}</div>
        <v-card-subtitle style="padding-top: 0px;">{{
          unit.address
        }}</v-card-subtitle>
      </div>
      <v-card-actions>
        <v-btn
          class="checkUnitStock"
          v-if="unit.product_stock.length > 0"
          @click="sendUnitInventoryData(unit)"
        >
          {{ $t('inventory') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false
    }
  },
  methods: {
    sendUnitInventoryData(unit) {
      this.$emit('unit-inventory', unit)
    },
    reserve() {
      this.loading = true
      setTimeout(() => (this.loading = false), 2000)
    }
  },
  props: {
    unit: Object
  }
}
</script>

<style lang="scss" scoped>
.unitStockCard {
  height: 280px;
  margin: 20px 10px !important;
  background: rgba(128, 128, 128, 0.1) !important;
}

.checkUnitStock {
  background-color: var(--bg-light) !important;
  border: none;
  color: var(--bright);
  box-shadow: none;
  font-weight: 600;
  margin: auto;
}

.card-title {
  width: 240px;
  padding-top: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  margin-top: 35px;
  margin: 10px;
  text-align: center;
  font-size: 1.5rem;
  font-weight: 800;
}
.bold {
  font-weight: 700 !important;
}

@media screen and (min-width: 500px) {
  .unitStockCard:hover {
    background: rgba(128, 128, 128, 0.2) !important;
    box-shadow: rgba(0, 0, 0, 0.117647) 0px 1px 6px,
      rgba(0, 0, 0, 0.117647) 0px 1px 4px;
    margin: 10px !important;
    transform: scale(1.03);
  }
}

@media screen and (max-width: 780px) {
  .unitStockCard {
    height: auto !important;
  }
}
@media screen and (max-width: 500px) {
  .unitStockCard {
    margin: 20px auto !important;
  }
  .card-title {
    width: 225px !important;
    margin-top: 10px;
    line-height: 30px;
  }
}
@media only screen and (min-device-width: 300px) and (max-device-width: 359px) {
  .card-title {
    width: 240px;
    font-size: 1.2rem;
    text-align: left;
  }
}

@media only screen and (min-device-width: 360px) and (max-device-width: 379px) {
  .card-title {
    width: 270px;
  }
}
</style>
